export class BlobFile {
  filename: string;
  fileSize: number;
  format: string;
  type: string;
  blob: Blob;
}
